// extracted by mini-css-extract-plugin
export default {"ScreenXXSMin":"(min-width: 544px)","White":"#FFFFFF","willFade":"Gdac0dc","cvBanner":"G8f48dc","menuLoadingErrorMessage":"Gd4260f"};